var data = {
	"body": "<g fill=\"none\"><path d=\"M12.261 15.015a.75.75 0 0 1 .102 1.494l-.102.006H2.827a.75.75 0 0 1-.102-1.493l.102-.007h9.434zm5.018-5.519a.75.75 0 0 1 .102 1.493l-.102.007H2.827a.75.75 0 0 1-.102-1.493l.102-.007h14.452zm-4.023-6.044a.75.75 0 0 1 .102 1.493l-.102.007H2.826a.75.75 0 0 1-.101-1.493l.102-.007h10.429z\" fill=\"currentColor\"/></g>",
	"width": 20,
	"height": 20
};
export default data;
